import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import { AgenciesService, AgencyConfigDto } from 'src/Services/API';

export const useGetAgencyConfig = (
  agencyId?: string,
  brandCode?: string,
  config?: UseQueryOptions<AgencyConfigDto | undefined, Error>
) => {
  return useQuery<AgencyConfigDto | undefined, Error>(
    ['agency-config', agencyId],
    async () => {
      if (!agencyId) return undefined;
      return await AgenciesService.agenciesControllerGetConfig({
        agencyId,
        brandCode: brandCode ?? '',
      });
    },
    {
      refetchOnWindowFocus: false,
      ...config,
    }
  );
};
